// Values in a client quote and a performer payout have different recipients.
// Keep them separate and never reconstruct the client total from a payout.
const number = (value) => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
export const formatApplicationMoney = (value) => number(value)?.toLocaleString('ru-RU', { maximumFractionDigits: 2 }) ?? '—';

export function applicationFinance(application = {}) {
  const quote = application.current_quote;
  const pending = quote?.transfer_pending === true;
  const manual = application.estimated_price_is_manual === true;
  const breakdown = quote?.client_breakdown || application.price_breakdown || {};
  const clientTransfer = quote?.client_transfer || breakdown.client_transfer || {};
  const storedTotal = number(application.estimated_price);
  const total = quote ? number(pending ? quote.works_total : quote.client_total) : storedTotal;
  const works = number(quote?.works_total ?? breakdown.works_total);
  const customerTravel = pending ? null : number(clientTransfer.amount ?? application.client_transfer_amount);
  const surveyorTotal = number(application.estimated_surveyor_salary);
  const surveyorTravel = number(application.transfer_amount);
  const surveyorWork = surveyorTotal != null && surveyorTravel != null && surveyorTotal >= surveyorTravel
    ? Math.round((surveyorTotal - surveyorTravel) * 100) / 100 : null;
  const rows = [];
  const add = (label, amount, suffix = ' ₽') => {
    if (amount != null) rows.push({ label, value: `${formatApplicationMoney(amount)}${suffix}` });
  };
  add('Сохранённая сумма калькулятора заявки', number(application.calculator_amount));
  add(manual ? 'Итого для клиента (задано вручную)'
    : pending ? 'Работы для клиента без выезда' : quote ? 'Итого для клиента (текущий расчёт)' : 'Итого для клиента (сохранённый расчёт)', total);
  add(manual ? 'Работы по расчёту (справочно)' : 'Работы и доп. услуги после скидок', works);
  if (pending) rows.push({ label: 'Выезд для клиента', value: 'Стоимость уточнит менеджер' });
  else add(manual ? 'Выезд клиента по расчёту (справочно)' : 'Выезд для клиента', customerTravel);
  if (customerTravel != null && !clientTransfer.is_manual && number(clientTransfer.km) > 0 && number(clientTransfer.rate) != null) {
    rows.push({ label: 'Расчёт выезда клиента', value: `${formatApplicationMoney(clientTransfer.km)} км × ${formatApplicationMoney(clientTransfer.rate)} ₽/км` });
  }
  if (surveyorTotal != null) {
    add('Обмерщику всего, включая выезд (сохранённый расчёт)', surveyorTotal);
    add('Из них работа и доп. услуги обмерщика', surveyorWork);
    add('Из них компенсация выезда обмерщику', surveyorTravel);
  }
  if (number(application.transfer_km) > 0) add('Километраж выезда в одну сторону', number(application.transfer_km), ' км');
  const warnings = [];
  if (!quote && !manual && storedTotal != null && number(breakdown.total) != null
      && Math.abs(storedTotal - number(breakdown.total)) > 0.01) {
    warnings.push('Сохранённая сумма отличается от расшифровки. Откройте заявку и проверьте расчёт перед созданием события.');
  }
  if (!quote && !manual && works === 0 && customerTravel > 0 && !(breakdown.services || []).length) {
    warnings.push('В сохранённом расчёте нет стоимости основных работ — указан только выезд. Выберите услуги в заявке и сохраните расчёт.');
  }
  return { total, pending, manual, rows, warnings };
}
